import { useParams } from 'react-router-dom';
import { useAuth } from '@helios/auth-firebase-web';
import { SidebarPackagesPanel } from '../../shell/SidebarPackagesPanel';

// PRD.262 — Full patient Packages page.
//
// Mirrors the patient Pharmacy page pattern: the sidebar Packages panel shows
// a compact summary + "View All Packages", and this page is the full surface
// where staff redeem benefits. It reuses the SidebarPackagesPanel component so
// the redeem / reverse / activate / suspend logic is shared verbatim.
//
// Redeeming a medicine or product benefit still routes to Pharmacy: the zero-
// balance redemption invoice line appears in the patient's Pharmacy "Ready to
// Dispense" list, where the batch is chosen and stock is deducted. No stock is
// touched here.
export function PatientPackagesPage() {
  const params = useParams<{ id: string }>();
  const patientId = params.id ?? '';
  const { claims, user } = useAuth();
  const orgId = claims?.activeOrg ?? '';
  const roles = orgId ? (claims?.orgs?.[orgId]?.roles ?? []) : [];
  const isAdmin = roles.includes('admin');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ marginBottom: 'var(--sp-4)' }}>
        <h2
          style={{
            fontSize: 'var(--font-size-xl)',
            fontWeight: 'var(--font-weight-semi)',
            lineHeight: 'var(--line-height-xl)',
            color: 'var(--text)',
            margin: 0,
          }}
        >
          Patient Packages
        </h2>
        <p
          style={{
            fontSize: 'var(--font-size-sm)',
            color: 'var(--text-muted)',
            margin: '2px 0 0',
          }}
        >
          Redeem this patient&rsquo;s package benefits. Redeeming a medicine or product sends it to
          Pharmacy, where the batch is selected and stock is deducted.
        </p>
      </div>

      <div
        style={{
          maxWidth: 760,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--sp-4)',
        }}
      >
        {/* No onViewAll here — this IS the full page. Redemptions are not tied
            to an encounter from this route, so no visit is attached. */}
        <SidebarPackagesPanel
          patientId={patientId}
          userId={user?.uid ?? null}
          isAdmin={isAdmin}
          activeEncounterId={null}
        />
      </div>
    </div>
  );
}
